// extracted by mini-css-extract-plugin
export default {"section_title":"DropdownMultiselect_section_title__FdRPl","checkbox_wrapper":"DropdownMultiselect_checkbox_wrapper__u-S28","selected":"DropdownMultiselect_selected__-3WEe"};